import { FC, ReactNode } from 'react';
import { useCan } from './useCan';
import { PermInput } from './permissions';

interface CanProps {
  /** Permission(s) required to render `children`. Written via dot access. */
  perm: PermInput | PermInput[];
  /** When `perm` is an array: 'any' (default) or 'all' must match. */
  mode?: 'any' | 'all';
  children: ReactNode;
  /** Rendered when the permission check fails. Defaults to nothing. */
  fallback?: ReactNode;
}

/**
 * Declaratively renders `children` only when the current user holds the
 * required permission(s).
 *
 *   <Can perm={[brand.create.CreateBrand]}>
 *     <CreateBrandButton />
 *   </Can>
 */
export const Can: FC<CanProps> = ({ perm, mode = 'any', children, fallback = null }) => {
  const can = useCan();
  return can(perm, mode) ? children : fallback;
};

export default Can;
